import React, { useRef, useEffect } from "react";

const BG_VOLUME = 0.85;
const src = `${process.env.PUBLIC_URL || ""}/assets/audio/background.mp3`;

export default function BackgroundMusic() {
  const ref = useRef(null);

  useEffect(() => {
    const a = ref.current;
    if (!a) return undefined;

    a.volume = BG_VOLUME;
    a.loop = true;

    const tryPlay = async () => {
      a.volume = BG_VOLUME;
      await a.play();
    };

    const shouldPlay = () =>
      document.visibilityState === "visible" && document.hasFocus();

    const removeUnlockListeners = () => {
      document.removeEventListener("pointerdown", unlockAndPlay);
      document.removeEventListener("click", unlockAndPlay);
      document.removeEventListener("touchstart", unlockAndPlay);
      document.removeEventListener("keydown", unlockAndPlay);
    };

    const syncPlayback = async () => {
      if (shouldPlay()) {
        try {
          await tryPlay();
          removeUnlockListeners();
        } catch {
          // Autoplay may still be blocked until a user gesture.
        }
      } else {
        a.pause();
      }
    };

    const unlockAndPlay = () => {
      syncPlayback();
    };

    syncPlayback();

    document.addEventListener("pointerdown", unlockAndPlay);
    document.addEventListener("click", unlockAndPlay);
    document.addEventListener("touchstart", unlockAndPlay, { passive: true });
    document.addEventListener("keydown", unlockAndPlay);
    document.addEventListener("visibilitychange", syncPlayback);
    window.addEventListener("focus", syncPlayback);
    window.addEventListener("blur", syncPlayback);

    return () => {
      removeUnlockListeners();
      document.removeEventListener("visibilitychange", syncPlayback);
      window.removeEventListener("focus", syncPlayback);
      window.removeEventListener("blur", syncPlayback);
      a.pause();
    };
  }, []);

  return (
    <audio
      ref={ref}
      src={src}
      loop
      preload="auto"
      playsInline
      aria-hidden="true"
    />
  );
}
